import FeaturesItemImage from '@klv/molecules/features-item-image';
import Buttons from '@klv/molecules/buttons';
import { generateClassName } from '@klv/shared/utils/functions';
import Grid from '@klv/utils/grid';
import * as styles from './styles/featuresItem.module.scss';
import type { IFeaturesItemProps } from './types';

const FeaturesItem = ({
  variant, type, feature,
}: IFeaturesItemProps) => {
  const contentColorVariant = variant === 'dark' ? 'light' : 'dark';

  return (
    <Grid as="article">
      <hr className={generateClassName([styles.styledBorder, styles[variant]])} />
      {type === 'text' && (
        <div
          className={generateClassName(
            [
              styles.styledHeaderLeftContent,
              'contentHeaderListView1',
              styles.columnTextOne,
              styles[variant],
            ])}
        >
          {feature.leftColumnText}
        </div>
      )}
      {feature?.leftColumnImage && type === 'image'
        && <FeaturesItemImage variant={variant} image={feature.leftColumnImage} link={feature.link} />}
      <div className={styles.feature}>
        <h3 
          className={generateClassName(
            [
              styles.styledHeaderContent,
              'contentHeaderListView2',
              styles[variant],
            ])}
        >
          {feature.heading}
        </h3>
        {feature?.body && (
          <p
          className={generateClassName(
            [
              'p2',
              styles.styledBodyContent,
              styles[variant],
            ])} 
            dangerouslySetInnerHTML={{ __html: feature.body }}
          />
        )}
        {feature?.buttons?.length && (
          <Buttons
            buttons={feature.buttons}
            variants={['tertiary']}
            buttonColor={contentColorVariant}
            className={styles.styledButtons}
          />
        )}
      </div>
    </Grid>
  );
};

export default FeaturesItem;
